import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["keyboard", "error"];
  static values = {
    allowedChars: { type: String, default: "A-Za-z" },
  };

  connect() {
    this.unwantedPattern = new RegExp(`[^${this.allowedCharsValue}]`, "g");

    this.beforeinputEventListener = this.beforeinputEvent.bind(this);
    this.inputEventListener = this.inputEvent.bind(this);
    this.keyDownEventListener = this.keyDownEvent.bind(this);
    this.keyboardTargets.forEach(input => {
      input.previousValue = input.value;
      input.addEventListener("beforeinput", this.beforeinputEventListener);
      input.addEventListener("input", this.inputEventListener);
      input.addEventListener("keydown", this.keyDownEventListener);
      input.addEventListener("blur", this.hideErrorHighlight.bind(this, input));
      input.addEventListener("compositionstart", this.restrictComposition.bind(this, input));
      this.hideError(input);
    }, this);

    // $(document).on("opening", "[data-remodal-id=modalKeyBind]", this.hideErrorMessage.bind(this));
  }

  disconnect() {
    this.keyboardTargets.forEach(input => {
      input.removeEventListener("beforeinput", this.beforeinputEventListener);
      input.removeEventListener("input", this.inputEventListener);
      input.removeEventListener("keydown", this.keyDownEventListener);
      input.removeEventListener("blur", this.hideErrorHighlight);
    }, this);

    // $(document).off("opening", "[data-remodal-id=modalKeyBind]", this.hideErrorMessage);
  }

  beforeinputEvent(event) {
    event.target.previousValue = event.target.value;
  }

  inputEvent(event) {
    event.target.value = event.target.previousValue;
  }

  keyDownEvent(event) {
    const key = event.key;
    if (!this.checkInput(key, event.target)) {
      event.preventDefault();
    }
  }

  restrictComposition(input) {
    input.disabled = true;
    requestAnimationFrame(() => {
      input.disabled = false;
      input.focus();
    });
  }

  checkInput(key, element) {
    if (key.length > 1) {
      // 制御コードや特殊キーの場合
      this.showError(element);
      return false;
    }

    const filtered = key.replace(this.unwantedPattern, "");
    if (filtered !== key) {
      this.showError(element);
      return false;
    }

    this.hideError(element);
    return true;
  }

  showError(element) {
    // this.showErrorMessage();
    this.showErrorHighlight(element);
  }

  hideError(element) {
    // this.hideErrorMessage();
    this.hideErrorHighlight(element);
  }

  showErrorMessage() {
    this.errorTarget.style.opacity = "1";
  }

  hideErrorMessage() {
    this.errorTarget.style.opacity = "0";
  }

  showErrorHighlight(element) {
    element.classList.add("is-error");
  }

  hideErrorHighlight(element) {
    element.classList.remove("is-error");
  }
}
